module.exports = __webpack_public_path__ + "static/img/idCarC.915d7fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/idCarC.png
// module id = 2UY+
// module chunks = 1